import { Typography } from 'design_system/src';
import { priceFormatFinancial } from 'models/shared/helpers/prices';
import { Sku, SkuStatusEnum } from 'models/sku/interfaces/sku.interface';
import { VehicleDetail } from 'models/vehicle-detail/interfaces/vehicle-detail.interface';

export const isVehicleDetailComplete = (detail: VehicleDetail): boolean =>
	!!(
		detail.engineType &&
		detail.maxSpeedKmh != null &&
		detail.maxPower &&
		detail.maxTorque &&
		detail.fuelEfficiencyKml != null &&
		detail.fuelSystem &&
		detail.fuelCapacityLiters != null &&
		detail.transmissionType &&
		detail.transmissionSpeeds != null &&
		detail.coolingSystem &&
		detail.frontSuspension &&
		detail.rearSuspension &&
		detail.frontBrakes &&
		detail.rearBrakes &&
		detail.frontTire &&
		detail.rearTire &&
		detail.dimensions?.lengthMm != null &&
		detail.dimensions?.widthMm != null &&
		detail.dimensions?.heightMm != null &&
		detail.dimensions?.wheelbaseMm != null &&
		detail.dimensions?.seatHeightMm != null &&
		detail.dimensions?.loadCapacityKg != null
	);

export const skuListColumns = (
	skusWithDetails: Set<string>,
	onToggleStatus: (sku: Sku) => void,
) => [
	{
		label: 'img',
		weight: 1,
		render: (row: Sku) => (
			<div className="vehicle_list_img">
				{row.images?.[0]?.url ? (
					<img
						className="img dim_100_per"
						src={row.images[0].url}
						alt={row.description}
						style={{ objectFit: 'cover', width: '100%', height: '100%' }}
					/>
				) : (
					<div
						className="img dim_100_per"
						style={{
							background: '#f0f0f0',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Typography scale="xsmall" weight="400" textColor="neutral_500">
							Sin img
						</Typography>
					</div>
				)}
			</div>
		),
	},
	{
		label: 'sku',
		weight: 2,
		render: (row: Sku) => (
			<Typography scale="medium" weight="600" textColor="neutral_900">
				{row.code}
			</Typography>
		),
	},
	{
		label: 'marca',
		weight: 1,
		render: (row: Sku) => (
			<Typography scale="medium" weight="400" textColor="neutral_700">
				{row.brandName}
			</Typography>
		),
	},
	{
		label: 'modelo',
		weight: 1,
		render: (row: Sku) => (
			<Typography scale="medium" weight="400" textColor="neutral_700">
				{row.modelName}
				{row.version ? ` ${row.version}` : ''}
			</Typography>
		),
	},
	{
		label: 'año+cc',
		weight: 1,
		render: (row: Sku) => (
			<Typography scale="medium" weight="400" textColor="neutral_700">
				{row.year} · {row.cc}cc
			</Typography>
		),
	},
	{
		label: 'precio desde',
		weight: 1,
		render: (row: Sku) => (
			<Typography scale="medium" weight="600" textColor="neutral_900">
				{priceFormatFinancial(row.minPrice ?? 0, 0)}
			</Typography>
		),
	},
	{
		label: 'status',
		weight: 1,
		render: (row: Sku) => {
			const isActive = row.status !== SkuStatusEnum.INACTIVE;
			return (
				<div className="display_flex flex_col flex_align_center flex_gap_sm">
					<button
						type="button"
						onClick={(e) => {
							e.stopPropagation();
							onToggleStatus(row);
						}}
						style={{
							background: 'none',
							border: 'none',
							cursor: 'pointer',
							padding: 0,
						}}
					>
						<Typography
							scale="xsmall"
							weight="600"
							textColor={isActive ? 'green_300' : 'red_300'}
						>
							{isActive ? 'Activo' : 'Inactivo'}
						</Typography>
					</button>
					{!skusWithDetails.has(row._id) && (
						<Typography scale="xsmall" weight="600" textColor="red_300">
							Falta información
						</Typography>
					)}
				</div>
			);
		},
	},
];
